module.exports = __webpack_public_path__ + "img/courseRecordVideo.88a403c4.png";